var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_IS_PREVAILS_MUTUAL_INVEST_FUND'
      )
    }},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
        _vm.$parent.project.SETTING_TABLE.allData
          .UF_IS_PREVAILS_MUTUAL_INVEST_FUND
      ),expression:"\n        $parent.project.SETTING_TABLE.allData\n          .UF_IS_PREVAILS_MUTUAL_INVEST_FUND\n      "}],staticClass:"sel-dropdown i-main-style i-wid-13",attrs:{"disabled":_vm.$parent.$parent.projectDisabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$parent.project.SETTING_TABLE.allData
          , "UF_IS_PREVAILS_MUTUAL_INVEST_FUND", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":1}},[_vm._v("Да")]),_vm._v(" "),_c('option',{domProps:{"value":0}},[_vm._v("Нет")])]),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_IS_PREVAILS_MUTUAL_INVEST_FUND"
        ))+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }